const path = "current_date_message";

export const getCurrentDate = (t: any) => {
    const currentDateMessage = t(path)

    return currentDateMessage;
}